<template>
    <div class="task-container" style="margin-bottom:10px">
        <el-table :data="tableData" height="700" border style="width: 100%" :header-cell-style="rowStyle"
                  cell-style="rowStyle">
            <el-table-column prop="taskId" label="ID" width="70"></el-table-column>
            <el-table-column prop="taskName" label="任务名称" width="550"></el-table-column>
            <el-table-column prop="totalQualityCount" label="总质控人数">
                <template slot="header">
                    <span>总质控人数</span>
                    <el-tooltip effect="light" content="本任务已质控总人数" placement="bottom" >
                        <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;" />
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="myQualityCount" label="我的质控人数">
                <template slot="header">
                    <span>我的质控人数</span>
                    <el-tooltip effect="light" content="我的质控总人数" placement="bottom" >
                        <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;" />
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="todayQualityCount" label="今日质控人数">
                <template slot="header">
                    <span>今日质控人数</span>
                    <el-tooltip effect="light" content="我的今日质控人数" placement="bottom" >
                        <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;" />
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="qualitySuccessRatio" label="质控合格率">
                <template slot="header">
                    <span>质控合格率</span>
                    <el-tooltip effect="light" content="我提交的质控合格数量/我提交的质控总量" placement="bottom" >
                        <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;" />
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.qualitySuccessRatio}}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="examineSuccessRatio" label="审核通过率">
                <template slot="header">
                    <span>审核通过率</span>
                    <el-tooltip effect="light" content="我提交的质控在质控终审中的通过率" placement="bottom" >
                        <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;" />
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.examineSuccessRatio}}%</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button style="font-size: 15px" size="mini"
                               @click="goToPage('internalQualityControl',scope.row.taskId,scope.row.taskName)" type="text">开始质控
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>
<script type="text/ecmascript-6">
    import {mapGetters, mapMutations, mapState} from "vuex";
    import {
        RestFeedbackOutControllerGetFollowupTaskPatientInfo,
    } from '@src/assets/js/api.js'
    export default {
        name: "task-container",
        data() {
            return {};
        },
        props: {
            tableData: {
                type: Array,
            }
        },
        computed: {
            ...mapGetters(["userid", "questionId"]),
        },
        mounted() {

        },
        methods: {
            ...mapMutations(["setTaskCenterId", "setTaskType","setTaskTitle", "setQuestion"]),
            goToPage(page, taskId,taskName) {
                this.setTaskTitle(taskName);
                this.getFollowupTaskPatientInfoAsnyc({
                    userId: sessionStorage.getItem('userid'),
                    followupTaskId: taskId
                })
                    .then(res => {
                        if (res.status == 0) {
                            localStorage.setItem('taskId', taskId)
                            sessionStorage.setItem('taskTitle',taskName)
                            this.$router.push({
                                path: `/${page}`
                            })
                        } else {
                            this.$message.error('暂无需要抽查任务')
                        }
                    })
            },
            rowStyle({row, rowIndex}) {
                if (rowIndex == 0) {
                    return 'color:#000;background:rgba(136, 136 ,136,0.25);border-color:rgb(230,230,230);cursor:pointer;font-size:17px'
                }
            }, rowStyle1({row, rowIndex}) {
                return 'color:#000;font-size:15px'

            },
            async getFollowupTaskPatientInfoAsnyc(p) {
                let request = new RestFeedbackOutControllerGetFollowupTaskPatientInfo()
                request.p_followupTaskId = p.followupTaskId
                request.p_userId = p.userId
                await request.send()
                return request.result
            },
        }
    }
</script>
<style scoped lang="scss">

</style>
